module.exports = __webpack_public_path__ + "static/media/container-icon.ff8ef911.svg";